import React from 'react';
// Bootstrap CSS
import "bootstrap/dist/css/bootstrap.min.css";
// Bootstrap Bundle JS
import "bootstrap/dist/js/bootstrap.bundle.min";
import './App.css';
import About from './components/about/About';
import Header from './components/header/Header';
import Skills from './components/skills/Skills';
import Stack from './components/skills/Stack';
import Resume from './components/resume/Resume';
import Work from './components/work/Work';
import Footer from './components/footer/Footer';

function App() {
  return (
    <div>
      <Header/>
      <About/>
      <Skills/>
      <Stack/>
      <Work/>
      <Resume/>
      <Footer/>
    </div>
  );
}

export default App;
